import tippy from 'tippy.js';

const CAPTIONS = document.querySelectorAll('.figure__caption');


CAPTIONS.forEach((item) => {
	const button = item.querySelector('.figure__caption__toggle');
	const tooltip = item.querySelector('.figure__caption__tooltip');

	if (button && tooltip) {
		tippy(button, {
			content: tooltip.innerHTML,
			theme: 'light',
			placement: 'top',
			animation: 'shift-away',
			expanded: 'auto',
			interactive: true,
			zIndex: 9999,
			allowHTML: true,
		});
	}

});
